export default __webpack_public_path__ + "static/media/workouttimes_4@3x.5db05504.jpg";